import React from 'react';
import { injectIntl } from 'react-intl';

import { Modal } from 'sa-ui';

import messages from './simulatedUpdatedAnswerSheetConfirmationModal';

/*
[~marcos.andrei], configurar a tradução das mensagens de retorno do correctAnswerSheet.php:

"Answer sheet uploaded with success." = "Cartão-resposta carregado com sucesso."

"There is already a correction for this student" = "Já existe uma correção para este aluno"

"Student not found" = "Aluno não encontrado"

"File type not supported. Only .jpg and .png files can be uploaded." = "Tipo de arquivo não suportado. Apenas arquivos .jpg e .png podem ser carregados."

"This user has no permission for this idCSchool" = "Este usuário não tem permissão para carregar cartões-resposta para esta escola"

"Error on scan, please contact the administrator." = "Erro na leitura, por favor entre em contato com o administrador"

Pode ignorar os textos que já tiverem sido traduzidos.

Obrigado!
*/

function getMessage(error) {
  switch (true) {
    case /There is already a correction for this student/g.test(error):
      return messages.errorAlreadyExists;
    case /Student not found/g.test(error):
      return messages.errorStudentNotFound;
    case /File type not supported/g.test(error):
      return messages.errorFileNotSupported;
    case /This user has no permission for this idCSchool/g.test(error):
      return messages.errorPermissionDenied;
    case /Error on scan, please contact the administrator/g.test(error):
      return messages.errorScan;
    case error === undefined:
      return messages.successMessage;
    default:
      return messages.errorGeneric;
  }
}
function SimulatedUpdateAnswerSheetConfirmationModal({
  isOpen,
  singularFile,
  onClose,
  intl,
  onBack,
  onContinue,
  amount,
  ...props
}) {
  const message = getMessage(props.error);
  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      icon={props.error ? 'ti-close' : 'ti-thumb-up'}
      title={intl.formatMessage(messages.title)}
      subtitle={intl.formatMessage(message)}
      buttons={[
        {
          label: intl.formatMessage(messages.close),
          onClick: onContinue,
          primary: true,
        },
      ]}
      small
    />
  );
}

export default injectIntl(SimulatedUpdateAnswerSheetConfirmationModal);
